import { cliente } from './api'
import { obtenerTokenStorage } from './sessionStorage'

export default {
  obtenerPersona(persona) {
    return cliente.get('/persona/persona', {
      params: {
        numero: persona.numero,
        /// id_produto: persona.id_producto,
        id_tipo_persona: persona.id_tipo_persona,
        telefono: persona.telefono,
      },
      headers: {
        Authorization: obtenerTokenStorage(),
      },
    })
  },
  guardarFirmaAutografaDigital(request) {
    return cliente.post('/persona/guardarFirmaDigital', request, {
      headers: {
        Authorization: obtenerTokenStorage(),
      },
    })
  },
  obtenerLocalidad(cp) {
    return cliente.get('/Catalogo/localidad_por_cp', {
      params: {
        id_localidad: cp,
      },
      headers: {
        Authorization: obtenerTokenStorage(),
      },
    })
  },
  actualizarDomicilioProspecto(request) {
    const newDomicilio = {
      numeroProspecto: request.datosPersonales.numero
        ? request.datosPersonales.numero
        : 0,
      id_tipo_persona: request.tipoPersona ? request.tipoPersona : 0,
      id_domicilio: request.Id_domicilio,
      calle: request.datosDomicilio.calle
        ? request.datosDomicilio.calle
        : 'N/A',
      no_Ext: request.datosDomicilio.numExt
        ? request.datosDomicilio.numExt
        : '',
      no_int: request.datosDomicilio.numInt
        ? request.datosDomicilio.numInt
        : '',
      cp: request.datosDomicilio.cp ? request.datosDomicilio.cp : 0,
      id_colonia: request.datosDomicilio.selectedColonia.Id_Colonia_CNBV
        ? request.datosDomicilio.selectedColonia.Id_Colonia_CNBV
        : request.datosDomicilio.selectedColonia,
      id_localidad: request.datosDomicilio.selectedMunicipio.id_localidad,
      id_entidad_federativa:
        request.datosDomicilio.selectedEntidad.id_entidad_federativa,
      id_pais: 1,
    }
    const config = {
      headers: {
        Authorization: obtenerTokenStorage(),
      },
    }
    return cliente.post(
      '/persona/actualiza_domicilio_prospecto',
      newDomicilio,
      config
    )
    // return cliente.post('/persona/actualiza_domicilio_prospecto', {
    //   params: {
    //     id_localidad: cp,
    //   },
    //   headers: {
    //     Authorization: obtenerTokenStorage(),
    //   },
    // })
  },
  verificarSocio(request) {
    if (request) {
      var id_entidad_federativa = 0
      // console.log('lareq', request)
      this.obtenerLocalidad(request.Codigo_Postal)
        .then((result) => {
          if (result.status != 200) {
            console.error(result.data.Mensaje)
            return
          }
          const data = result.data
          if (data.Codigo != 200) {
            console.error(data.Mensaje)
            return
          }
          // this.postObtienePersona(data.Modelo)
          id_entidad_federativa = data.ID_ENTIDAD_FEDERATIVA
        })
        .catch((err) => {
          console.error(err)
        })
      // console.log('lareq', request)
      const req = {
        nombre_s: request.Nombre_s,
        apellido_paterno: request.Apellido_Paterno,
        apellido_materno: request.Apellido_Materno,
        genero: request.Curp ? request.Curp.charAt(10) : 'H',
        fecha_nacimiento: request.Fecha_Nacimiento,
        id_entidad_federativa: id_entidad_federativa,
        id_sorteo: 1,
        id_tipo_proceso: 2,
      }
      const config = {
        headers: {
          Authorization: obtenerTokenStorage(),
        },
      }
      return cliente.post('/sorteo/verifica_socio', req, config)
    } else return null
  },
}
